import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import DashboardPage from 'internal-portal/sharedComponents/DashboardPage'
import Card from 'components/Card'
import { Box, Container } from 'components/Layout'
import { Locations } from './Locations'

export const USERS_PAGE_LENGTH = 10

const LocationList: React.VFC<RouteComponentProps> = () => (
  <DashboardPage>
    <Container>
      <Box mb="2rem">
        <Card>
          <Locations />
        </Card>
      </Box>
    </Container>
  </DashboardPage>
)

export { LocationList }
